/* eslint-disable */
export default {
    page: {
        'LOADING': 'Loading...',
        'NOT_FOUND': 'Page not found. Sorry about that. :(',
        'LOADING_ERROR': 'There was a problem loading data. Try reloading this page.'
    },
    notify: {
        'REFRESH_ERROR': 'Access token has expired. Please sign in with your login and password.',
        'SERVER_ERROR': 'Server error occured.',
        'REQUEST_ERROR': 'Couldn\'t send the request. Check your connection and try again.'
    },
    header: {
        'LOGIN': 'Sign in',
        'MY_EXAMS': 'My exams',
        'NEW_EXAMINER': 'New examiner',
        'NEW_EXAM': 'New exam',
        'NEW_STUDENTS': 'New students'
    },
    exam: {
        'START': 'Starts',
        'END': 'Ends',
        'TIMING': 'Prep time',
        'PAPER': 'Paper',
        'TIME_UNIT': 'min',
        action: {
            'GIVE_PAPERS': 'Give out papers',
            'GIVE_PAPER': 'Give a paper',
            'INVITE_STUDENT': 'Invite',
            'REVERT_STUDENT': 'Revert back',
            'REVERT_STUDENT_SHORT': 'Revert back',
            'FINISH': 'Finish the exam',
            'FINISH_SHORT': 'Finish'
        }
    },
    exams: {
        'DELETE_FAILURE': 'Couldn\'t delete the exam.',
        'SAVE_FAILURE': 'Couldn\'t download session links.',
        'STUB': 'You don\'t have any exams yet.'
    },
    status: {
        'NOT_STARTED': 'Not started',
        'AWAITING_PAPER': 'Awaiting paper',
        'PREPARING': 'Preparing for',
        'READY': 'Ready',
        'STARTED': 'Started',
        'FINISHED': 'Finished'
    },
    student: {
        'TIMING': 'Preparation time:',
        text: {
            'NOT_STARTED': 'The exam has not started yet',
            'AWAITING_PAPER': 'The exam has started<br>Please wait, you\'ll be given a paper in a minute',
            'PREPARING': '',
            'READY': '',
            'STARTED': '',
            'FINISHED': 'The exam is finished'
        },
        action: { 'READY': 'I\'m ready to answer' }
    },
    newExam: {
        'TITLE': 'Add new exam',
        label: {
            'NAME': 'Name',
            'START': 'Start',
            'END': 'End',
            'TIMING': 'Preparation time (minutes)',
            'COMMISSION': 'Examination board'
        },
        awn: {
            'SEND_FORM': 'Creating exam...',
            'SEND_PAPERS': 'Uploading papers...',
            'EXAM_SUCCESS': 'Exam created!',
            'EXAM_FAILURE': 'Couldn\'t create the exam.',
            'PAPERS_SUCCESS': 'Papers uploaded! Everything\'s done.',
            'PAPERS_FAILURE': 'Couldn\'t upload the papers, but the exam is fine. Try editing it.',
            'PROCESSING_FAILURE': 'Couldn\'t process the file. Check contents of the file and try again.'
        },
        error: {
            'FIELD_REQUIRED': 'All fields are required',
            'COMMISSION_REQUIRED': 'Examination board is required',
            'PAPERS_REQUIRED': 'Papers file is required',
            'INVALID_FILE_TYPE': 'Invalid file type'
        },
        'NAME_PLACEHOLDER': 'Enter exam name',
        'START_END_PLACEHOLDER': 'Choose time and date',
        'TIMING_PLACEHOLDER': 'Specify preparation time',
        'UPLOAD_BUTTON': 'Upload file',
        'UPLOAD_HELP': 'XLSX file containing a list of papers (paper number, title, content)',
        'SUBMIT_BUTTON': 'Add'
    },
    selectMembers: {
        label: {
            'SELECT': 'Click to select',
            'SELECTED': 'Selected',
            'DESELECT': 'Click to deselect'
        },
        'PLACEHOLDER': 'Add a member of the exam board',
        'SELECTION': '{n} member selected | {n} members selected',
        'NO_OPTIONS': 'List is empty'
    },
    datepicker: {
        'PLACEHOLDER': 'Choose date and time',
        'NEXT_MONTH': 'Next months',
        'PREV_MONTH': 'Previous month',
        'TIME': 'Set time:',
        'WEEKDAYS': [
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat',
            'Sun'
        ],
        'MONTHS': [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        'DISPLAY': 'MM/DD/YYYY H:mm A'
    },
    newStudents: {
        'TITLE': 'Add students',
        label: { 'EXAM': 'Exam' },
        awn: {
            'SEND_FORM': 'Adding students...',
            'UPLOAD_SUCCESS': 'Students added! Session links download will start shortly.',
            'UPLOAD_FAILURE': 'Couldn\'t add students. Check contents of the file and try again.',
            'LINKS_FAILURE': 'Couldn\'t download session links. Try doing it again from the exam card.',
            'PROCESSING_FAILURE': 'Couldn\'t process the file. Check contents of the file and try again.'
        },
        error: {
            'EXAM_REQUIRED': 'Exam is required',
            'STUDENTS_REQUIRED': 'Students file is required',
            'INVALID_FILE_TYPE': 'Invalid file type'
        },
        'UPLOAD_BUTTON': 'Upload file',
        'UPLOAD_HELP': 'XLSX file containing a list of students (email, first name, last name)',
        'SUBMIT_BUTTON': 'Add',
        'SUBMIT_DONE': 'Done!',
        'DOWNLOAD_LINK': 'Download session links'
    },
    selectExam: {
        'PLACEHOLDER': 'Choose an exam',
        'NO_OPTIONS': 'List is empty',
        label: {
            'SELECT': 'Click to select',
            'DESELECT': 'Click to deselect'
        }
    },
    baseExamForm: {
        label: {
            'NAME': 'Name',
            'START': 'Start',
            'END': 'End',
            'TIMING': 'Preparation time (minutes)',
            'COMMISSION': 'Examination board',
            'PROCTORING': 'Proctoring'
        },
        awn: { 'PROCESSING_FAILURE': 'Couldn\'t process the file. Check contents of the file and try again.' },
        error: {
            'FIELD_REQUIRED': 'All fields are required',
            'COMMISSION_REQUIRED': 'Examination board is required',
            'PAPERS_REQUIRED': 'Papers file is required',
            'INVALID_FILE_TYPE': 'Invalid file type',
            'PROCTORING_REQUIRED': 'Proctoring type is required',
            'INVALID_DATETIME': 'Exam ends before it starts'
        },
        'NAME_PLACEHOLDER': 'Enter exam name',
        'START_END_PLACEHOLDER': 'Choose time and date',
        'TIMING_PLACEHOLDER': 'Specify preparation time',
        'PROCTORING_PLACEHOLDER': 'Choose proctoring type',
        'UPLOAD_BUTTON': 'Upload file',
        'UPLOAD_HELP': 'XLSX file containing a list of papers (paper number, title, content)',
        'ONLINE_PROC': 'Synchronous',
        'OFFLINE_PROC': 'Asynchronous',
        'IDENTIFICATION_PROC': 'Identification',
        'AUTO_PROC': 'Auto'
    },
    editExam: {
        'SUBMIT_BUTTON': 'Save',
        'TITLE': 'Change exam',
        awn: {
            'SEND_FORM': 'Saving exam...',
            'SEND_PAPERS': 'Saving papers...',
            'EXAM_SUCCESS': 'Exam saved!',
            'EXAM_FAILURE': 'Couldn\'t edit the exam.',
            'PAPERS_SUCCESS': 'Papers saved! Everything\'s done.',
            'PAPERS_FAILURE': 'Couldn\'t save the papers, but the exam is saved.'
        }
    },
    newExaminer: {
        'TITLE': 'Add new examiner',
        'SUBMIT_BUTTON': 'Add',
        'EMAIL_PLACEHOLDER': 'Enter a valid email address',
        'PASSWORD_PLACEHOLDER': 'Make up a password for this account',
        'PASSWORD2_PLACEHOLDER': 'Confirm the password',
        'FIRST_NAME_PLACEHOLDER': 'First name',
        'LAST_NAME_PLACEHOLDER': 'Last name',
        'PASSWORD_HELP': '8 characters or more',
        error: {
            'FIELD_REQUIRED': 'All fields are required',
            'PASSWORD_MISMATCH': 'Passwords don\'t match',
            'COMPANY_REQUIRED': 'You haven\'t been assigned a company'
        },
        awn: {
            'SEND_FORM': 'Creating new examiner...',
            'CREATE_SUCCESS': 'Examiner created!',
            'CREATE_ERROR': 'Couldn\'t create the examiner. Please, correct the errors and try again.'
        },
        label: {
            'EMAIL': 'Email',
            'PASSWORD': 'Password',
            'PASSWORD2': 'Confirm password',
            'FIRST_NAME': 'First name',
            'LAST_NAME': 'Last name'
        }
    },
    profile: {
        'TITLE': 'Profile',
        'SUBMIT_BUTTON': 'Save',
        'OLD_PASSWORD_PLACEHOLDER': 'Enter your current password',
        'PASSWORD_PLACEHOLDER': 'Enter new password',
        'PASSWORD2_PLACEHOLDER': 'Confirm new password',
        awn: {
            'SEND_FORM': 'Saving...',
            'SUCCESS': 'Changes has been saved.',
            'FAILURE': 'Coudn\'t save changes. Please, correct the errors and try again.'
        },
        section: { 'CHANGE_PASSWORD': 'Change password' },
        error: { 'PASSWORD_MISMATCH': 'Passwords don\'t match' },
        label: {
            'EMAIL': 'Email',
            'OLD_PASSWORD': 'Current password',
            'PASSWORD': 'New password',
            'PASSWORD2': 'Confirm new password'
        }
    },
    login: {
        'TITLE': 'Sign in',
        'SUBMIT_BUTTON': 'Sign in',
        'EMAIL_PLACEHOLDER': 'Email address',
        'PASSWORD_PLACEHOLDER': 'Password',
        label: {
            'EMAIL': 'Email',
            'PASSWORD': 'Password'
        },
        error: {
            'FIELD_REQUIRED': 'All fields are required',
            'INVALID_CREDENTIALS': 'Incorrect email and/or password'
        }
    },
    filters: {
        'DATE_ASC': 'Oldest first',
        'DATE_DESC': 'Latest first',
        'HIDE': 'Hide past exams'
    }
};
